// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: var(--wellsky-sand-tint);
}

.dashboard-header {
  background: var(--wellsky-indigo);
  color: white;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dashboard-header h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
}

.header-right {
  display: flex;
  gap: 24px;
  align-items: center;
}

.device-status {
  display: flex;
  gap: 8px;
  align-items: center;
}

.user-menu {
  display: flex;
  gap: 12px;
  align-items: center;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
  padding-left: 24px;
}

.user-name {
  font-size: 14px;
  opacity: 0.9;
}

.logout-button {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.4);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.logout-button:hover {
  background-color: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.6);
}

.logout-button:active {
  transform: scale(0.98);
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.ready {
  background-color: rgba(76, 175, 80, 0.2);
  color: #4CAF50;
}

.status-badge.loading {
  background-color: rgba(255, 152, 0, 0.2);
  color: #ff9800;
}

.status-badge.error {
  background-color: rgba(244, 67, 54, 0.2);
  color: #f44336;
}

.status-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  background-color: currentColor;
  border-radius: 50%;
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.active-call-bar-error {
  background-color: #ffebee;
  border-bottom: 1px solid #f44336;
  color: #d32f2f;
  padding: 8px 24px;
  font-size: 13px;
  font-weight: 500;
}

.dashboard-container {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.dashboard-content {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}

.dashboard-footer {
  background-color: var(--wellsky-indigo);
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  padding: 12px;
  font-size: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.dashboard-footer p {
  margin: 0;
}

.debug-info {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: var(--wellsky-white);
  border: 1px solid var(--color-border);
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-size: 12px;
  z-index: 1000;
}

.debug-info details {
  padding: 0;
}

.debug-info summary {
  padding: 8px 12px;
  cursor: pointer;
  background: #f8f9fa;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  user-select: none;
}

.debug-info summary:hover {
  background: #e9ecef;
}

.debug-content {
  padding: 12px;
  max-height: 300px;
  overflow-y: auto;
}

.debug-content p {
  margin: 6px 0;
  font-family: 'Monaco', 'Courier New', monospace;
  color: var(--wellsky-indigo);
}

.debug-content strong {
  color: var(--wellsky-blue);
}

@media (max-width: 768px) {
  .dashboard-header {
    flex-direction: column;
    gap: 16px;
  }

  .header-right {
    flex-direction: column;
    gap: 12px;
    width: 100%;
    border-left: none;
    border-top: 1px solid rgba(255, 255, 255, 0.3);
    padding-left: 0;
    padding-top: 12px;
  }

  .user-menu {
    width: 100%;
    justify-content: space-between;
    border-left: none;
    padding-left: 0;
  }

  .device-status {
    justify-content: center;
  }

  .debug-info {
    bottom: 10px;
    right: 10px;
    font-size: 11px;
  }

  .debug-content {
    max-height: 200px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,8CAA8C;IAC9C,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".dashboard {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  background-color: var(--wellsky-sand-tint);\n}\n\n.dashboard-header {\n  background: var(--wellsky-indigo);\n  color: white;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.dashboard-header h1 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.header-right {\n  display: flex;\n  gap: 24px;\n  align-items: center;\n}\n\n.device-status {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.user-menu {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  border-left: 1px solid rgba(255, 255, 255, 0.3);\n  padding-left: 24px;\n}\n\n.user-name {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.logout-button {\n  background-color: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.logout-button:hover {\n  background-color: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.6);\n}\n\n.logout-button:active {\n  transform: scale(0.98);\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge.ready {\n  background-color: rgba(76, 175, 80, 0.2);\n  color: #4CAF50;\n}\n\n.status-badge.loading {\n  background-color: rgba(255, 152, 0, 0.2);\n  color: #ff9800;\n}\n\n.status-badge.error {\n  background-color: rgba(244, 67, 54, 0.2);\n  color: #f44336;\n}\n\n.status-dot {\n  display: inline-block;\n  width: 6px;\n  height: 6px;\n  background-color: currentColor;\n  border-radius: 50%;\n  animation: blink 1s infinite;\n}\n\n@keyframes blink {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n\n.active-call-bar-error {\n  background-color: #ffebee;\n  border-bottom: 1px solid #f44336;\n  color: #d32f2f;\n  padding: 8px 24px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.dashboard-container {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n}\n\n.dashboard-content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n.dashboard-footer {\n  background-color: var(--wellsky-indigo);\n  color: rgba(255, 255, 255, 0.8);\n  text-align: center;\n  padding: 12px;\n  font-size: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.dashboard-footer p {\n  margin: 0;\n}\n\n.debug-info {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background: var(--wellsky-white);\n  border: 1px solid var(--color-border);\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  font-size: 12px;\n  z-index: 1000;\n}\n\n.debug-info details {\n  padding: 0;\n}\n\n.debug-info summary {\n  padding: 8px 12px;\n  cursor: pointer;\n  background: #f8f9fa;\n  border-bottom: 1px solid #eee;\n  font-weight: 600;\n  user-select: none;\n}\n\n.debug-info summary:hover {\n  background: #e9ecef;\n}\n\n.debug-content {\n  padding: 12px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.debug-content p {\n  margin: 6px 0;\n  font-family: 'Monaco', 'Courier New', monospace;\n  color: var(--wellsky-indigo);\n}\n\n.debug-content strong {\n  color: var(--wellsky-blue);\n}\n\n@media (max-width: 768px) {\n  .dashboard-header {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .header-right {\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n    border-left: none;\n    border-top: 1px solid rgba(255, 255, 255, 0.3);\n    padding-left: 0;\n    padding-top: 12px;\n  }\n\n  .user-menu {\n    width: 100%;\n    justify-content: space-between;\n    border-left: none;\n    padding-left: 0;\n  }\n\n  .device-status {\n    justify-content: center;\n  }\n\n  .debug-info {\n    bottom: 10px;\n    right: 10px;\n    font-size: 11px;\n  }\n\n  .debug-content {\n    max-height: 200px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
